import { useRef } from 'react'
import { View } from 'react-native'
import LottieView from 'lottie-react-native'

const ANIMATION_SIZE = 200

interface ILottieEffectProps {
  source: ReturnType<typeof require>
  onComplete?: () => void
  speed?: number
  size?: number
}

export function LottieEffect({
  source,
  onComplete,
  speed = 1,
  size = ANIMATION_SIZE,
}: ILottieEffectProps) {
  const onCompleteRef = useRef(onComplete)
  onCompleteRef.current = onComplete

  return (
    <View
      pointerEvents="none"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: size,
        height: size,
        marginTop: -(size / 2),
        marginLeft: -(size / 2),
        overflow: 'visible',
        zIndex: 9999,
        elevation: 9999,
      }}
    >
      <LottieView
        source={source}
        autoPlay
        loop={false}
        speed={speed}
        resizeMode="cover"
        style={{ width: size, height: size }}
        onAnimationFinish={() => {
          onCompleteRef.current?.()
        }}
      />
    </View>
  )
}
